import { type ChartData } from './chartConfigUtils';
import CurrencyValueChart from './CurrencyValueChart';

interface PaidContractCommissionChartProps {
    readonly data: readonly ChartData[];
    readonly loading?: boolean;
    readonly referenceValue?: number;
    readonly currency?: 'EUR' | 'LEI';
}
function PaidContractCommissionChart({
    data,
    loading = false,
    referenceValue,
    currency,
}: PaidContractCommissionChartProps): JSX.Element {
    return (
        <CurrencyValueChart
            data={data}
            loading={loading}
            referenceValue={referenceValue}
            currency={currency}
            config={{
                chartType: 'column',
                yAxisTitleKeyEur: 'statistics.charts.paidContractCommissionEur',
                yAxisTitleKeyLei: 'statistics.charts.paidContractCommissionLei',
                yAxisTitleFallbackEur: 'Redemption Interest (EUR)',
                yAxisTitleFallbackLei: 'Redemption Interest (Lei)',
                color: '#eb2f96',
                seriesNameKey: 'statistics.charts.paidContractCommission',
                seriesNameFallback: 'Redemption Interest',
            }}
        />
    );
}

export default PaidContractCommissionChart;
